module.exports = __webpack_public_path__ + "static/media/terms.197953ea.md";